import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TimeInputAmPmComponent } from './time-input-ampm.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, MatInputModule],
  declarations: [TimeInputAmPmComponent],
  exports: [TimeInputAmPmComponent],
})
export class TimeInputAmPmModule {}
